export default __webpack_public_path__ + "static/ChangeTheWorld-c8fc428f55dce352c229fd835252158d.mp4";